import Vue from 'vue';
import vuetify from '@/plugins/vuetify';
import CloneModalDialog from '@/components/core/dialogs/CloneModalDialog.vue';

function CloneDialog({ message, modalWidth = '300' }) {
	// let dummy=message;dummy=yesBtnText;dummy=noBtnText;JSON.stringify(dummy)  //because eslint config

	let modal = document.createElement('div');
	document.body.appendChild(modal);
	return new Promise((resolve) => {
		let vModal = new Vue({
			vuetify,
			el: modal,
			components: {
				CloneModalDialog,
			},
			data: {
				showDialog: true,
				message,
				modalWidth,
			},
			methods: {
				kill() {
					modal = vModal.$el;
					vModal.$destroy();
					if (modal.parentNode) {
						modal.parentNode.removeChild(modal);
					}
				},
				onConfirm(item) {
					this.showDialog = false;
					let response = {
						success: true,
						name: item,
					};
					resolve(response);
					this.kill();
				},
				onCancel() {
					this.showDialog = false;
					resolve(0);
					this.kill();
				},
			},
			template: `<clone-modal-dialog :showDialog="showDialog" :modalWidth="modalWidth":message="message" @confirm="onConfirm" @cancel="onCancel" />`,
		});
	});
}

export default CloneDialog;
